import React, { useState } from 'react';
import classes from './index.module.scss';
import { Link, useHistory } from 'react-router-dom';


const MessageOptions = ({ id_template_type, submitRef}) => {
  const link = `/email-template-by-type?template_email_by_type=${id_template_type}`;

  return (
    <div className={classes.Message_Footer} style={{display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap'}}>
      <div>
        <button
          ref={submitRef}
          type="submit"
          className='btnSizes filledBtn'
        >
          Submit
        </button>
        <Link
          to={link}
          className="btnSizes transparentBtn border-0 ml-5"
        >
          Cancel
        </Link>
      </div>
    </div>
  )
}

export default MessageOptions;